import { useState } from "react";

import { useAuth } from "@warden-ui/common";
import { parseQueryString, parseAmplifyConfig } from "@warden-ui/common";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CardContentSignInPassword } from "@warden-ui/card-components";
import { cloneSearchParams } from "@warden-ui/common";
import { CPPageBody } from "@warden-ui/common-components";
import { useTranslation } from "react-i18next";

const defaultQueryString: {[key: string]: string} = {
  email: "",
  region: "",
}

export default function SigninPassword() {
  const auth = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const queryString = parseQueryString(searchParams, defaultQueryString);
  const amplifyConfig = parseAmplifyConfig(queryString);
  auth.configureAmplify(amplifyConfig);

  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const configureFailed = () => {
    if (!auth.isConfigured) {
      console.error("Auth is not configured.");
      return true;
    }
    return false;
  }

  const onClickEmailSignin = async (password: string) => {
    if (configureFailed()) {
      return;
    }

    if (password.length === 0) {
      setErrorMessage("Enter a password.");
      return;
    }

    setLoading(true);
    const result = await auth.signIn(queryString.email, password, amplifyConfig);
    if (result.success) {
      setErrorMessage("");
    } else {
      setErrorMessage(t('signin.error.password_incorrect'));
    }
    setLoading(false);
  };

  const onClickForgotPassword = () => {
    const params = cloneSearchParams(searchParams);
    params.set("email", queryString.email);

    navigate(`/reset_password/request/?${params.toString()}`);
  }

  if (auth.isSignedIn) {
    navigate(`/redirect?${searchParams.toString()}`);
  } else {
    if (auth.needMFA) {
      const params = cloneSearchParams(searchParams);
      params.set("email", queryString.email);

      navigate(`/signin/mfa?${params.toString()}`);
    }
  }

  return (
    <CPPageBody
      onBackClicked={() => {
        navigate(`/?${searchParams.toString()}`);
      }}
    >
      <CardContentSignInPassword
        email={queryString.email}
        onClickSignin={onClickEmailSignin}
        onClickForgotPassword={onClickForgotPassword}
        errorMessage={errorMessage}
        loading={loading}
      />
    </CPPageBody>
  );
}
